import { ITableFilterItem } from '@components/common/UTable/UTable';
import { DatePickerProps } from 'antd';
import dayjs from 'dayjs';

import { DRUG_BATCH_HISTORY_OPERATIONS } from '@/shared/pharmacy/enum';
import { DateTimeFormat } from '@/utils/dateUtils';
import { enumValuesToOptions } from '@/utils/utils';

export const filterSchema = [
  {
    label: 'Период',
    key: 'createdAt',
    type: 'dateRange',
    payload: {
      formatStartOnSubmit: (date: dayjs.Dayjs) =>
        date.startOf('day').format(DateTimeFormat.LOCAL_DATE_TIME),
      formatEndOnSubmit: (date: dayjs.Dayjs) =>
        date.endOf('day').format(DateTimeFormat.LOCAL_DATE_TIME),
      disabledDate: (current: DatePickerProps['value']) => {
        return current && current > dayjs().endOf('day');
      },
    },
  },
  {
    label: 'Препараты',
    key: 'drugName',
    type: 'text',
  },
  {
    label: 'Партия',
    key: 'batchNumber',
    type: 'text',
  },
  {
    label: 'Тип действия',
    key: 'operation',
    type: 'select',
    payload: {
      options: enumValuesToOptions(DRUG_BATCH_HISTORY_OPERATIONS),
    },
  },
] as ITableFilterItem[];
